(() => {
  if (window.ArDrBogoSignalsLoaded) return;
  window.ArDrBogoSignalsLoaded = true;

  const eligibleFormSelector =
    '[data-arista-bogo-eligible="true"] form[data-type="add-to-cart-form"]';
  const propertyName = 'properties[_arista_bogo_eligible]';

  const markForm = (form) => {
    if (form.querySelector(`input[name="${propertyName}"]`)) return;

    const eligibilityInput = document.createElement('input');
    eligibilityInput.type = 'hidden';
    eligibilityInput.name = propertyName;
    eligibilityInput.value = 'true';
    form.appendChild(eligibilityInput);
  };

  const syncEligibleForms = (root = document) => {
    if (root instanceof Element && root.matches(eligibleFormSelector)) markForm(root);
    root.querySelectorAll?.(eligibleFormSelector).forEach(markForm);
  };

  const initialiseGiftProperties = (root = document) => {
    root.querySelectorAll?.('[data-arista-gift-toggle]').forEach((toggle) => {
      if (toggle.dataset.aristaGiftReady === 'true') return;
      toggle.dataset.aristaGiftReady = 'true';
      const panel = toggle.closest('.arista-gift-property')?.querySelector('[data-arista-gift-message]');
      const message = panel?.querySelector('textarea[name="properties[Gift message]"]');
      const sync = () => {
        if (!panel) return;
        panel.hidden = !toggle.checked;
        toggle.setAttribute('aria-expanded', String(toggle.checked));
        if (!toggle.checked && message) message.value = '';
      };
      toggle.addEventListener('change', sync);
      sync();
    });
  };

  const initialisePersonalization = (root = document) => {
    root.querySelectorAll?.('[data-arista-personalization-required]').forEach((wrapper) => {
      wrapper.querySelectorAll('input[name="properties[Choose an alphabet charm]"], input[data-arista-full-name]').forEach((input) => {
        if (input.dataset.aristaPersonalizationReady === 'true') return;
        input.dataset.aristaPersonalizationReady = 'true';
        input.addEventListener(input.hasAttribute('data-arista-full-name') ? 'input' : 'change', () => {
          const error = wrapper.querySelector('[data-arista-personalization-error]');
          if (error) error.hidden = true;
          input.removeAttribute('aria-invalid');
        });
      });
    });
  };

  const syncProductProperties = (root = document) => {
    initialiseGiftProperties(root);
    initialisePersonalization(root);
  };

  const start = () => {
    syncEligibleForms();
    syncProductProperties();

    // Omit only empty optional fields from the native form payload. Keep
    // nonempty names/messages and all private tracking/BOGO properties intact.
    document.addEventListener('formdata', (event) => {
      if (!(event.target instanceof HTMLFormElement) ||
          !event.target.matches('form[data-type="add-to-cart-form"]')) return;
      for (const key of ['properties[Gift message]', 'properties[Customization Details ( If any )]']) {
        const values = event.formData.getAll(key);
        if (values.length && values.every(value => typeof value === 'string' && value.trim() === '')) {
          event.formData.delete(key);
        }
      }
    }, true);

    document.addEventListener(
      'submit',
      (event) => {
        const form = event.target instanceof HTMLFormElement ? event.target : null;
        const wrapper = form?.querySelector('[data-arista-personalization-required]');
        if (!wrapper) return;
        const nameInput = wrapper.querySelector('input[data-arista-full-name]');
        if (nameInput) {
          const rawName = nameInput.value;
          const name = rawName.trim();
          if (name && name.length <= 100 && !/[\u0000-\u001f\u007f-\u009f]/.test(rawName)) {
            nameInput.value = name;
            nameInput.removeAttribute('aria-invalid');
            return;
          }
          event.preventDefault();
          event.stopImmediatePropagation();
          const error = wrapper.querySelector('[data-arista-personalization-error]');
          if (error) {
            error.textContent = name ? 'Please use a name of up to 100 characters without control characters.' : 'Please enter a name for this bracelet before adding it.';
            error.hidden = false;
          }
          nameInput.setAttribute('aria-invalid', 'true');
          nameInput.focus();
          return;
        }
        const selected = wrapper.querySelector('input[name="properties[Choose an alphabet charm]"]:checked');
        if (selected) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        const error = wrapper.querySelector('[data-arista-personalization-error]');
        if (error) error.hidden = false;
        wrapper.querySelector('input[name="properties[Choose an alphabet charm]"]')?.focus();
      },
      true
    );

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) {
            syncEligibleForms(node);
            syncProductProperties(node);
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => {
    syncEligibleForms(event.target);
    syncProductProperties(event.target);
  });
})();
